/// <reference types="@angular/localize" />

import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';

import { AppModule } from './app/app.module';
import * as Sentry from "@sentry/angular";

Sentry.init({
  dsn: "https://95e876e05c82ee39740f83734d4730f7@o4508176665804800.ingest.de.sentry.io/4508176670457936",
  integrations: [
    Sentry.browserTracingIntegration(),
    Sentry.replayIntegration(),
  ],
  // Tracing
  tracesSampleRate: 1.0, //  Capture 100% of the transactions
  // Set 'tracePropagationTargets' to control for which URLs distributed tracing should be enabled
  tracePropagationTargets: ["localhost", /^https:\/\/yourserver\.io\/api/],
  // Session Replay
  replaysSessionSampleRate: 0.1, // This sets the sample rate at 10%. You may want to change it to 100% while in development and then sample at a lower rate in production.
  replaysOnErrorSampleRate: 1.0, // If you're not already sampling the entire session, change the sample rate to 100% when sampling sessions where errors occur.
});


platformBrowserDynamic().bootstrapModule(AppModule)
  .catch(err => console.error(err));

  // if ('serviceWorker' in navigator) {

  //   navigator.serviceWorker.ready.then(reg => {
  //   })

  //   navigator.serviceWorker.register('/firebase-messaging-sw.js')
  //   .then(function(response) {
  //     // Service worker registration done
  //     console.log('Registration Successful', response);

  //   }, function(error) {
  //     // Service worker registration failed
  //     console.log('Registration Failed', error);
  //   })
  // }
